import React from 'react';
import { Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTypography = styled(Typography)({
  maxWidth: 400,
  fontStyle: 'italic',
  textAlign: 'center',
});

export function SubscriptionTerms() {
  return (
    <StyledTypography variant="body2">
      The subscription can be managed from within the app and you are able to cancel it at any time. If you have any questions regarding the subscription checkout our{" "}
      <Link underline="always" color="inherit" target="_blank" href="https://storypoint.poker/story-point-poker-terms-of-service.pdf">
        terms of service
      </Link>{" "}
      or contact us at{" "}
      <Link underline="always" color="inherit" href="mailto:support@storypoint.poker">
        support@storypoint.poker
      </Link>
    </StyledTypography>
  );
}

